import { render, staticRenderFns } from "./contentInfo.vue?vue&type=template&id=60a122c2"
import script from "./contentInfo.vue?vue&type=script&lang=js"
export * from "./contentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports